module.exports = __webpack_public_path__ + "static/media/next_section.1f6ade43.svg";